var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.891 4.558a.625.625 0 0 0 0 .884L12.45 10l-4.56 4.558a.625.625 0 1 0 .884.884l5-5a.625.625 0 0 0 0-.884l-5-5a.625.625 0 0 0-.884 0",
  clipRule: "evenodd"
})));
export default SvgChevronRight;